import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import { maxScores } from "./quizQuestions.js";
import '../App.css';

class Results extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        return (
            <Paper style={{ "text-align": "left", "box-shadow": "0px 6px 33px 8px rgba(194,186,194,0.66)", "margin-top": "10%", "padding": "10%" }}>
                <div style={{ "margin-bottom": "1%", "font-size": "200%" }}><b>Overview</b></div>
                {
                    Object.keys(this.props.data).map(
                        (key, index) => {
                        return <div style={{"margin-top": "5%", "font-size": "200%"}}>{key}: {this.props.data[key]} points out of a total of {maxScores[key]} points</div>
                        }
                    )
                }
                <button onClick={this.props.function} style={{"margin-top": "5%", "font-size": "150%"}}>
                    Submit
                </button>
            </Paper>

        );
    }
}

export default Results;